import React, { useEffect, useRef, useState } from 'react';
import {IncidentsScreen} from '../screens/incidents/ui/screens/IncidentsScreen';
export default function IncidentsConfiguration() {

    return (
        <div>
           <IncidentsScreen></IncidentsScreen>
        </div>
    );
}